import React from 'react';
import bindAll from 'lodash.bindall';


class AixiongReload extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleReload'
        ]);
    }
    handleReload(){
        window.location.reload(true);
    }
    render () {
        return (
            <div onClick={this.handleReload} style={{marginLeft:'auto', cursor:'pointer', marginRight:'1rem'}}>
                更新
            </div>
        );
    }
};

export default AixiongReload;
